import Vue from 'vue';
import {
    Toast, Form, Field, Checkbox,
    Dialog, List, Rate, NavBar, Button, Tab,
    Tabs, Cell, Popup, Picker, Uploader, Calendar, Notify, Loading, NumberKeyboard, image,Overlay
} from 'vant';
import App from './App.vue';

import 'reset-css';
import './style/main.scss';

import router from './router/router';
import store from './store';
import Bridge from './helper/utils';
Vue.prototype.$bridge = Bridge;
// // import appStarter from '@x-tech/h5-app-starter/dist/index.js';
// import { $http } from '@/api';
// appStarter.installApp({ $http, router, store });

if (process.env.VUE_APP_ENV !== 'prod') {
    import(/* webpackChunkName: "vconsole" */ 'vconsole').then(m => {
        const VConsole = m.default;
        // 这里为了动态加载 是一个特例
        // eslint-disable-next-line no-new
        new VConsole();
    });
}

Vue
    .use(Toast)
    .use(Form)
    .use(Field)
    .use(Checkbox)
    .use(Dialog)
    .use(List)
    .use(Rate)
    .use(NavBar)
    .use(Button)
    .use(Tab)
    .use(Tabs)
    .use(Cell)
    .use(Popup)
    .use(Picker)
    .use(Uploader)
    .use(Calendar)
    .use(Notify)
    .use(Loading)
    .use(image)
    .use(NumberKeyboard)
    .use(Overlay)
;
Vue.prototype.$Toast = Toast;
Vue.config.productionTip = false;
new Vue({
    render: h => h(App),
    router,
    store,
}).$mount('#app');
